<template>
  <div class="wg-col wg-xs-12 wg-md-4" style="padding:2%;">
    <wg-modal
      v-if="openModal"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="closeModal"
      :confirmOnClose="true"
      :confirmOnCloseMsg="
        $anm22.strLang(
          lang,
          'Discard changes?',
          'Scartare le modifiche?'
        )
      "
    >
      <div slot="header">
        <span>{{ mode == 'edit' ? $anm22.strLang(lang, 'Edit', 'Modifica ' + currentModel.modelName ) : $anm22.strLang(lang, 'New', 'Nuovo') }}</span>
      </div>

      <div slot="body">
        <span>{{ $anm22.strLang(lang, 'Model name', 'Nome modello')}}</span>
        <div class="wg-col wg-xs-5">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentModel.modelName"
          />
          <div class="vertical-height-div" style="height:12px;"></div>
        </div>
        <span>{{ $anm22.strLang(lang, 'Misures', 'Misure')}}</span>
        <div class="vertical-height-div" style="height:12px;"></div>
        <div class="wg-row">
          <div
            class="wg-row input-row measure"
            v-for="(input,index) in fields"
            :key="'input'+index"
          >
            <div class="wg-col wg-xs-1">
              <div class="com-anm22-app-text-m">{{ index + 1 }}</div>
            </div>
            <div class="wg-col wg-xs-4">
              <input
                class="input-elem print-elem com-anm22-app-input-text"
                type="text"
                v-model="currentModel.modelSizes[input.name]"
              />
            </div>
            <div class="wg-col wg-xs-7">
              <div class="input-text com-anm22-app-text-m">{{ input.label }}</div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="addModel" />
          </div>
        </div>
      </div>
    </wg-modal>
    <div
      style="font-size:24px;"
      class="com-anm22-app-text-m"
    >{{$anm22.strLang(lang, "Models","Modelli")}}</div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div
      class="wg-row"
      style="height:49px;padding:5px;"
      v-for="(model,index) in models"
      :key="index"
    >
      <span style="padding:11px;">{{model.modelName}}</span>
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Edit', 'Modifica')"
        @click="selectModel(model)"
      />
      <div class="com-anm22-horizontal-div" style="width: 10px;"></div>
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Delete', 'Elimina')"
        @click="removeModel(model)"
      />
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Add model', 'Aggiungi modello')"
        @click="add"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      models: [],
      mode: "edit",
      openModal: false,
      currentModel: {
        modelSizes: {}
      },
      fields: [
        {
          name: "punto-spalla",
          label: "Punto spalle"
        },
        {
          name: "circ-torace",
          label: "Circonferenza torace"
        },
        {
          name: "circ-vita",
          label: "Circonferenza vita"
        },
        {
          name: "circ-bacino",
          label: "Circonferenza bacino"
        },
        {
          name: "da-pv-a-ginocchio",
          label: "Da punto vita a centro ginocchio"
        },
        {
          name: "da-pv-a-caviglia",
          label: "Da punto vita a caviglia"
        },
        {
          name: "da-pv-a-terra",
          label: "Da punto vita a terra"
        },
        {
          name: "da-cavallo-a-ginocchio",
          label: "Da cavallo a centro ginocchio"
        },
        {
          name: "manica-spalla-gomito",
          label: "Lunghezza manica da spalla a centro gomito"
        },
        {
          name: "manica-gomito-fondo",
          label: "Lunghezza manica da centro gomito a fondo"
        },
        {
          name: "circ-braccio",
          label: "Circonferenza braccio"
        },
        {
          name: "circ-avanbraccio",
          label: "Circonferenza avanbraccio"
        },
        {
          name: "circ-polso",
          label: "Circonferenza polso"
        },
        {
          name: "circ-coscia",
          label: "Circonferenza coscia"
        },
        {
          name: "circ-ginocchio",
          label: "Circonferenza ginocchio"
        },
        {
          name: "circ-polpaccio",
          label: "Circonferenza polpaccio"
        },
        {
          name: "circ-caviglia",
          label: "Circonferenza caviglia"
        },
        {
          name: "lung-vita",
          label: "Lunghezza vita"
        },
        {
          name: "altezza",
          label: "Altezza cm"
        },
        {
          name: "peso",
          label: "Peso kg"
        },
        {
          name: "",
          label: ""
        },
        {
          name: "manica-piegata-totale",
          label: "10+9 lunghezza manica piegata totale"
        },
        {
          name: "centro-davanti",
          label: "Centro davanti"
        },
        {
          name: "lung-fianco",
          label: "Lunghezza fianco"
        },
        {
          name: "ovetto",
          label: "Ovetto"
        },
        {
          name: "tratta-davanti",
          label: "Tratta davanti"
        },
        {
          name: "tratta-dietro",
          label: "Tratta dietro"
        },
        {
          name: "circ-collo",
          label: "Circonferenza collo"
        },
        {
          name: "circ-gomito",
          label: "Circonferenza gomito"
        },
        {
          name: "punto-seno",
          label: "Punto seno (donna)"
        },
        {
          name: "dist-seni",
          label: "Distanza seni (donna)"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      windowWidth: state => state.windowWidth
    })
  },
  methods: {
    loadData() {
      return this.$vlf("vircos-models-base")
        .getItems()
        .then(result => {
          if (result) {
            this.models = Object.values(result);
          }
        });
    },
    add() {
      this.currentModel = {};
      this.currentModel.modelSizes = {};
      this.openModal = true;
      this.mode = "new";
    },
    addModel() {
      this.$http
        .post("vircos/add", {
          mode: this.mode,
          model: this.currentModel
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$vlf("vircos-models-base").setItem(
            String(response.data.model.idVircosModelsBase),
            response.data.model
          );
          this.loadData();
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch(error => {
          console.log(error);
        });
    },
    removeModel(model) {
      this.$http
        .post("vircos/remove", {
          model: model
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$vlf("vircos-models-base")
            .removeItem(String(model.idVircosModelsBase))
            .then(result => {
              this.loadData();
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectModel(model) {
      this.mode = "edit";
      if (model.modelSizes.length == 0) {
        model.modelSizes = {};
      }
      this.openModal = true;
      this.currentModel = model;
    },
    closeModal() {
      this.openModal = false;
    }
  },
  created() {
    this.loadData();
    this.$http
      .get("vircos/models")
      .then(response => {
        const models = response.data.models;
        //map per salvare nel db locale i modelli
        models.map(model =>
          this.$vlf("vircos-models-base").setItem(
            String(model.idVircosModelsBase),
            model
          )
        );
        this.loadData();
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style lang="scss" scoped>
</style>
